import { cn } from "@/utils";
import DOMPurify from "dompurify";
import { useMemo } from "react";

interface Props {
  html?: string;
  className?: string;
  tiptapClassName?: string;
  shouldSanitize?: boolean;
}

export const RenderMessage = ({
  html,
  className,
  tiptapClassName = "tiptapChat",
  shouldSanitize = true,
}: Props) => {
  // Todo: Sanitize html before rendering to prevent XSS attacks
  const sanitizedHtml = useMemo(() => {
    if (!shouldSanitize || !html) return html;
    // Basic sanitization example, consider using a library like DOMPurify for better security
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target"],
    });
  }, [html, shouldSanitize]);

  return (
    <div
      className={cn(tiptapClassName, className)}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml || "" }}
    ></div>
  );
};

// Truncate content of message
export const TruncateMessageContent = ({
  html,
  shouldSanitize = true,
}: {
  html?: string;
  shouldSanitize?: boolean;
}) => {
  // Show ... if content has multiple lines
  const hasEllipsis = useMemo(() => {
    if (!html) return;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    return tempDiv.children.length > 1;
  }, [html]);

  // Todo: Sanitize html before rendering to prevent XSS attacks
  const sanitizedHtml = useMemo(() => {
    if (!shouldSanitize || !html) return html;
    // Basic sanitization example, consider using a library like DOMPurify for better security
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target"],
    });
  }, [html, shouldSanitize]);

  return (
    <div
      className={cn(
        "truncateTiptapContent",
        hasEllipsis && 'after:content-["..."]'
      )}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml || "" }}
    ></div>
  );
};
